import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Aún no se ha generado ninguna ronda", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", null, "Válinor", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Posición"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Jugador"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos a favor"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos en contra"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Diferencia de puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "tect-center" }, "General")
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", null, "Arda", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Posición"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Jugador"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos a favor"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Puntos en contra"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Diferencia de puntos"),
    /*#__PURE__*/_createElementVNode("th", { class: "tect-center" }, "General")
  ])
], -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Esperando resultados...", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Posición"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Jugador"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "P"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "PV"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "PD"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "+-"),
    /*#__PURE__*/_createElementVNode("th", { class: "tect-center" }, "L")
  ])
], -1)
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", null, "Esperando resultados...", -1)
const _hoisted_22 = [
  _hoisted_21
]

import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import CardPartidaTorneoMasLive from "@/components/PartidasTorneo/CardPartidaTorneoMasLive.vue";
import { useAuth } from "@/composables/useAuth";
import { Clasificacion } from "@/interfaces/Live";
import { PartidaTorneoMasDTO } from "@/interfaces/Partidas";
import { InscripcionTorneoCreadoDTO, Torneo } from "@/interfaces/Torneo";
import { getInscripcionesTorneo } from "@/services/InscripcionesService";
import { getPartidasTorneoMas, getTorneo } from "@/services/TorneosService";
import { appsettings } from "@/settings/appsettings";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetalleTorneoLiveMasView',
  setup(__props) {

const route = useRoute();
const idTorneo = ref<number>(Number(route.params.idTorneo));
const isLoading = ref<boolean>(false);
const isLoadingImage = ref<boolean>(false);
const torneo = ref<Torneo>();
const partidas = ref<PartidaTorneoMasDTO[]>([]);
const numeroRondas = ref<number[]>([]);
const partidasPorRonda = ref<Record<number, PartidaTorneoMasDTO[]>>({});
const { getidUsuario } = useAuth();
const idUsuarioLogger = ref<string | null>(getidUsuario.value);
const idUsuario = ref<number>();
const activeTab = ref(1);
const tabClasificacion = ref<number>(1);
const tabListas = ref<number>(0);
const clasificacion = ref<Clasificacion[]>([]);
const jugadoresZona1 = ref<Clasificacion[]>([]);
const jugadoresZona2 = ref<Clasificacion[]>([]);
const clasificacionDividida = ref<Clasificacion[]>([]);
const clasificacionZona1 = ref<Clasificacion[]>([]);
const clasificacionZona2 = ref<Clasificacion[]>([]);
const inscripciones = ref<InscripcionTorneoCreadoDTO[]>([]);

onMounted(async () => {
  if (idUsuarioLogger.value) idUsuario.value = parseInt(idUsuarioLogger.value);
  isLoading.value = true;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneo.value = responseTorneo.data;

    const responsePartidas = await getPartidasTorneoMas(idTorneo.value);
    partidas.value = responsePartidas.data;

    if (torneo.value) {
      numeroRondas.value = Array.from(
        { length: torneo.value.numeroPartidas },
        (_, index) => index + 1
      );
    }
    if (partidas.value) {
      partidasPorRonda.value = partidas.value.reduce((acc, partida) => {
        const { numeroRonda } = partida;
        if (!acc[numeroRonda]) {
          acc[numeroRonda] = [];
        }
        acc[numeroRonda].push(partida);
        return acc;
      }, {} as Record<number, PartidaTorneoMasDTO[]>);
    }
    tabClasificacion.value = numeroRondas.value.length + 1;

    try {
      const responseInscripciones = await getInscripcionesTorneo(
        idTorneo.value
      );
      inscripciones.value = responseInscripciones.data;
    } catch (error) {
      console.error(error);
    }

    calcularClasificacion();
  } catch (error) {
    console.error("calcularClasificacion", error);
  } finally {
    isLoading.value = false;
  }
});

const calcularClasificacion = async () => {
  const ranking: Record<
    number,
    {
      nick: string;
      victorias: number;
      puntosFavor: number;
      puntosContra: number;
      diferenciaPuntos: number;
      lider: number;
      idUsuario: number;
      idTorneo: number;
      empates: 0;
      derrotas: 0;
      puntosTorneo: 0;
    }
  > = {};
  const rankingDividido: Record<
    number,
    {
      nick: string;
      victorias: number;
      puntosFavor: number;
      puntosContra: number;
      diferenciaPuntos: number;
      lider: number;
      idUsuario: number;
      idTorneo: number;
      empates: 0;
      derrotas: 0;
      puntosTorneo: 0;
    }
  > = {};

  // Filtramos hasta la ronda 2 para dividir el grupo
  const partidasFiltradas = partidas.value?.filter(
    (partida) => partida.numeroRonda <= 2
  );

  partidasFiltradas?.forEach((partida) => {
    // Verifica que la partida esté validada por ambos usuarios
    if (partida.partidaValidadaUsuario1 && partida.partidaValidadaUsuario2) {
      const puntosUsuario1 = partida.resultadoUsuario1 ?? 0;
      const puntosUsuario2 = partida.resultadoUsuario2 ?? 0;
      const liderMuertoUsuario1 = partida.liderMuertoUsuario1 ? 1 : 0;
      const liderMuertoUsuario2 = partida.liderMuertoUsuario2 ? 1 : 0;

      // Inicializamos los jugadores si no están en el ranking
      if (!rankingDividido[partida.idUsuario1]) {
        rankingDividido[partida.idUsuario1] = {
          nick: partida.nick1,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario1,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }
      if (!rankingDividido[partida.idUsuario2]) {
        rankingDividido[partida.idUsuario2] = {
          nick: partida.nick2,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario2,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }

      // Actualizamos puntos a favor y en contra
      rankingDividido[partida.idUsuario1].puntosFavor += puntosUsuario1;
      rankingDividido[partida.idUsuario1].puntosContra += puntosUsuario2;
      rankingDividido[partida.idUsuario2].puntosFavor += puntosUsuario2;
      rankingDividido[partida.idUsuario2].puntosContra += puntosUsuario1;

      // Actualizamos la diferencia de puntos
      rankingDividido[partida.idUsuario1].diferenciaPuntos =
        rankingDividido[partida.idUsuario1].puntosFavor -
        rankingDividido[partida.idUsuario1].puntosContra;
      rankingDividido[partida.idUsuario2].diferenciaPuntos =
        rankingDividido[partida.idUsuario2].puntosFavor -
        rankingDividido[partida.idUsuario2].puntosContra;

      // Actualizamos las puntosTorneo
      if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
        rankingDividido[partida.idUsuario1].puntosTorneo += 3;
        rankingDividido[partida.idUsuario1].victorias += 1;
        rankingDividido[partida.idUsuario2].derrotas += 1;
      } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
        rankingDividido[partida.idUsuario2].puntosTorneo += 3;
        rankingDividido[partida.idUsuario2].victorias += 1;
        rankingDividido[partida.idUsuario1].derrotas += 1;
      } else {
        rankingDividido[partida.idUsuario1].puntosTorneo += 1;
        rankingDividido[partida.idUsuario2].puntosTorneo += 1;
        rankingDividido[partida.idUsuario1].empates += 1;
        rankingDividido[partida.idUsuario2].empates += 1;
      }

      // Lider muerto primero
      if (liderMuertoUsuario1) {
        rankingDividido[partida.idUsuario1].lider += 1;
      } else if (liderMuertoUsuario2) {
        rankingDividido[partida.idUsuario2].lider += 1;
      }
    }
  });

  clasificacionDividida.value = Object.values(rankingDividido).sort((a, b) => {
    // 1. Ordenar por puntosTorneo
    if (b.puntosTorneo !== a.puntosTorneo) {
      return b.puntosTorneo - a.puntosTorneo;
    }
    // 2. Ordenar por diferencia de puntos (puntos a favor - puntos en contra)
    if (b.diferenciaPuntos !== a.diferenciaPuntos) {
      return b.diferenciaPuntos - a.diferenciaPuntos;
    }
    // 3. Ordenar por puntos a favor
    if (b.puntosFavor !== a.puntosFavor) {
      return b.puntosFavor - a.puntosFavor;
    }
    // 4. Ordenar por quién ha matado al líder primero
    return b.lider - a.lider;
  });

  dividirClasificacionEnZonas();

  // Clasificacion normal
  partidas.value?.forEach((partida) => {
    // Verifica que la partida esté validada por ambos usuarios
    if (partida.partidaValidadaUsuario1 && partida.partidaValidadaUsuario2) {
      const puntosUsuario1 = partida.resultadoUsuario1 ?? 0;
      const puntosUsuario2 = partida.resultadoUsuario2 ?? 0;
      const liderMuertoUsuario1 = partida.liderMuertoUsuario1 ? 1 : 0;
      const liderMuertoUsuario2 = partida.liderMuertoUsuario2 ? 1 : 0;

      // Inicializamos los jugadores si no están en el ranking
      if (!ranking[partida.idUsuario1]) {
        ranking[partida.idUsuario1] = {
          nick: partida.nick1,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario1,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }
      if (!ranking[partida.idUsuario2]) {
        ranking[partida.idUsuario2] = {
          nick: partida.nick2,
          victorias: 0,
          puntosFavor: 0,
          puntosContra: 0,
          diferenciaPuntos: 0,
          lider: 0,
          idUsuario: partida.idUsuario2,
          idTorneo: partida.idTorneo,
          empates: 0,
          derrotas: 0,
          puntosTorneo: 0,
        };
      }

      // Actualizamos puntos a favor y en contra
      ranking[partida.idUsuario1].puntosFavor += puntosUsuario1;
      ranking[partida.idUsuario1].puntosContra += puntosUsuario2;
      ranking[partida.idUsuario2].puntosFavor += puntosUsuario2;
      ranking[partida.idUsuario2].puntosContra += puntosUsuario1;

      // Actualizamos la diferencia de puntos
      ranking[partida.idUsuario1].diferenciaPuntos =
        ranking[partida.idUsuario1].puntosFavor -
        ranking[partida.idUsuario1].puntosContra;
      ranking[partida.idUsuario2].diferenciaPuntos =
        ranking[partida.idUsuario2].puntosFavor -
        ranking[partida.idUsuario2].puntosContra;

      // Actualizamos las puntosTorneo
      if (partida.ganadorPartidaTorneo === partida.idUsuario1) {
        ranking[partida.idUsuario1].puntosTorneo += 3;
        ranking[partida.idUsuario1].victorias += 1;
        ranking[partida.idUsuario2].derrotas += 1;
      } else if (partida.ganadorPartidaTorneo === partida.idUsuario2) {
        ranking[partida.idUsuario2].puntosTorneo += 3;
        ranking[partida.idUsuario2].victorias += 1;
        ranking[partida.idUsuario1].derrotas += 1;
      } else {
        ranking[partida.idUsuario1].puntosTorneo += 1;
        ranking[partida.idUsuario2].puntosTorneo += 1;
        ranking[partida.idUsuario1].empates += 1;
        ranking[partida.idUsuario2].empates += 1;
      }

      // Lider muerto primero
      if (liderMuertoUsuario1) {
        ranking[partida.idUsuario1].lider += 1;
      } else if (liderMuertoUsuario2) {
        ranking[partida.idUsuario2].lider += 1;
      }
    }
  });

  inscripciones.value.forEach((inscripcion) => {
    const userId = inscripcion.idUsuario;
    if (ranking[userId]) {
      ranking[userId].puntosTorneo += inscripcion.puntosExtra;
    }
  });

  //Ordenar segun parametros
  clasificacion.value = Object.values(ranking).sort((a, b) => {
    // 1. Ordenar por puntosTorneo
    if (b.puntosTorneo !== a.puntosTorneo) {
      return b.puntosTorneo - a.puntosTorneo;
    }
    // 2. Ordenar por diferencia de puntos (puntos a favor - puntos en contra)
    if (b.diferenciaPuntos !== a.diferenciaPuntos) {
      return b.diferenciaPuntos - a.diferenciaPuntos;
    }
    // 3. Ordenar por puntos a favor
    if (b.puntosFavor !== a.puntosFavor) {
      return b.puntosFavor - a.puntosFavor;
    }
    // 4. Ordenar por quién ha matado al líder primero
    return b.lider - a.lider;
  });

  // Clasificacion por zonas
  clasificacionZona1.value = clasificacion.value.filter((jugador) =>
    jugadoresZona1.value.some((z) => z.idUsuario === jugador.idUsuario)
  );
  clasificacionZona2.value = clasificacion.value.filter((jugador) =>
    jugadoresZona2.value.some((z) => z.idUsuario === jugador.idUsuario)
  );

  type JugadorConEjercito = {
    nick: string;
    ejercito: string | null;
  };

  const jugadoresConEjercitos = partidas.value.reduce<JugadorConEjercito[]>(
    (acc, partida) => {
      acc.push({ nick: partida.nick1, ejercito: null });
      acc.push({ nick: partida.nick2, ejercito: null });
      return acc;
    },
    []
  );

  const listaEjercitos = appsettings.armies;

  const ejercitosJugadoresConBando = jugadoresConEjercitos.map((jugador) => {
    const ejercito = listaEjercitos.find((e) => e.name === jugador.ejercito);
    return {
      nick: jugador.nick,
      ejercito: jugador.ejercito,
      bando: ejercito ? ejercito.band : "desconocido",
      shortName: ejercito?.shortName,
    };
  });

  clasificacion.value = clasificacion.value.map((j) => {
    const datosEjercito = ejercitosJugadoresConBando.find(
      (e) => e.nick === j.nick
    );
    return {
      ...j,
      bando: datosEjercito?.bando ?? "desconocido",
      nombreCortoEjercito: datosEjercito?.shortName ?? undefined,
      ejercito: datosEjercito?.ejercito ?? undefined,
    };
  });
};

const dividirClasificacionEnZonas = () => {
  const totalJugadores = clasificacionDividida.value.length;
  const esImpar = totalJugadores % 2 !== 0;

  const mitad = Math.floor(totalJugadores / 2);
  const zona1Size = esImpar ? mitad + 1 : mitad;

  jugadoresZona1.value = clasificacionDividida.value.slice(0, zona1Size);
  jugadoresZona2.value = clasificacionDividida.value.slice(zona1Size);
};

//Este método determina si el jugador actual ha validado ya la partida o no.
const editarPartidaPJ = (partida: PartidaTorneoMasDTO) => {
  if (
    partida.idUsuario1 === idUsuario.value &&
    (partida.partidaValidadaUsuario1 === false ||
      partida.partidaValidadaUsuario1 === null)
  ) {
    return true;
  } else if (
    partida.idUsuario2 === idUsuario.value &&
    (partida.partidaValidadaUsuario2 === false ||
      partida.partidaValidadaUsuario2 === null)
  ) {
    return true;
  } else {
    return false;
  }
};

const soloValidarPJ = (partida: PartidaTorneoMasDTO) => {
  //Si somos el PJ1 y no hemos validado partida, y el PJ2 si ha validado, tenemos que validar
  if (
    partida.idUsuario1 === idUsuario.value &&
    (partida.partidaValidadaUsuario1 === false ||
      partida.partidaValidadaUsuario1 === null) &&
    partida.partidaValidadaUsuario2 === true
  ) {
    return true;
  } else if (
    partida.idUsuario2 === idUsuario.value &&
    (partida.partidaValidadaUsuario2 === false ||
      partida.partidaValidadaUsuario2 === null) &&
    partida.partidaValidadaUsuario1 === true
  ) {
    return true;
  } else {
    return false;
  }
};

// const formatDate = (date: string | null | undefined) => {
//   if (!date) return "N/A";
//   return new Date(date).toLocaleDateString();
// };

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, { class: "pa-4" }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingGandalf)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_tabs, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
              "fixed-tabs": ""
            }, {
              default: _withCtx(() => [
                (torneo.value?.mostrarListas)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: tabListas.value,
                      text: `Listas`,
                      value: tabListas.value
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numeroRondas.value, (n) => {
                  return (_openBlock(), _createBlock(_component_v_tab, {
                    key: n,
                    text: `Ronda ${n}`,
                    value: n
                  }, null, 8, ["text", "value"]))
                }), 128)),
                (torneo.value?.mostrarClasificacion)
                  ? (_openBlock(), _createBlock(_component_v_tab, {
                      key: tabClasificacion.value,
                      text: `Clasificación`,
                      value: tabClasificacion.value
                    }, null, 8, ["value"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_window, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((activeTab).value = $event))
            }, {
              default: _withCtx(() => [
                (partidas.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(numeroRondas.value, (n) => {
                  return (_openBlock(), _createBlock(_component_v_window_item, {
                    key: n,
                    value: n
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partidasPorRonda.value[activeTab.value!], (partida, index) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              cols: "12",
                              sm: "12",
                              md: "6",
                              lg: "6",
                              xl: "4",
                              class: "pb-0",
                              key: partida.idPartidaTorneo,
                              value: activeTab.value
                            }, {
                              default: _withCtx(() => [
                                (
                  partida.partidaValidadaUsuario1 === true &&
                  partida.partidaValidadaUsuario2 === true
                )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                      _createVNode(CardPartidaTorneoMasLive, {
                                        idUsuario: parseInt(idUsuarioLogger.value!),
                                        match: partida,
                                        mesa: `Mesa ${index + 1}`,
                                        completa: true,
                                        editarPartidaPJ: false,
                                        soloValidarPJ: false
                                      }, null, 8, ["idUsuario", "match", "mesa"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                      _createVNode(CardPartidaTorneoMasLive, {
                                        idUsuario: parseInt(idUsuarioLogger.value!),
                                        match: partida,
                                        mesa: `Mesa ${index + 1}`,
                                        completa: false,
                                        editarPartidaPJ: editarPartidaPJ(partida),
                                        soloValidarPJ: soloValidarPJ(partida)
                                      }, null, 8, ["idUsuario", "match", "mesa", "editarPartidaPJ", "soloValidarPJ"])
                                    ]))
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128)),
                (_openBlock(), _createBlock(_component_v_window_item, {
                  value: tabClasificacion.value,
                  key: tabClasificacion.value
                }, {
                  default: _withCtx(() => [
                    (idTorneo.value === 7)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (
                clasificacionZona1.value.length > 0 && clasificacionZona2.value.length > 0
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _hoisted_10,
                                (activeTab.value == tabClasificacion.value)
                                  ? (_openBlock(), _createBlock(_component_v_table, {
                                      key: 0,
                                      density: "compact"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_11,
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clasificacionZona1.value, (jugador, index) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: jugador.nick
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.nick), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.puntosTorneo), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.puntosFavor), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.puntosContra), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.diferenciaPuntos), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.lider), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_divider, { class: "my-5" }),
                                _hoisted_12,
                                (activeTab.value == tabClasificacion.value)
                                  ? (_openBlock(), _createBlock(_component_v_table, {
                                      key: 1,
                                      density: "compact"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_13,
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clasificacionZona2.value, (jugador, index) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: jugador.nick
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.nick), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.puntosTorneo), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.puntosFavor), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.puntosContra), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.diferenciaPuntos), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.lider), 1)
                                            ]))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (clasificacion.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                (activeTab.value == tabClasificacion.value)
                                  ? (_openBlock(), _createBlock(_component_v_table, {
                                      key: 0,
                                      density: "compact"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_19,
                                        _createElementVNode("tbody", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clasificacion.value, (jugador, index) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                              key: jugador.nick,
                                              class: _normalizeClass({
                      'good-bando': jugador.bando === 'good',
                      'evil-bando': jugador.bando === 'evil',
                    })
                                            }, [
                                              _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.nick), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.puntosTorneo), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.puntosFavor), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.puntosContra), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.diferenciaPuntos), 1),
                                              _createElementVNode("td", null, _toDisplayString(jugador.lider), 1)
                                            ], 2))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
                        ]))
                  ]),
                  _: 1
                }, 8, ["value"]))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])),
      _createVNode(_component_v_dialog, {
        modelValue: isLoadingImage.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isLoadingImage).value = $event)),
        persistent: "",
        width: "300"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, {
                class: "d-flex justify-center align-center",
                style: {"height":"150px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_progress_circular, {
                    indeterminate: "",
                    color: "blue-lighten-3",
                    size: 57
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})